import type { ComponentProps, ReactNode } from 'react';

import { cx } from '@mage-ui/styled-system/css';
import {
  textareaDescription,
  textareaError,
  textareaInput,
  textareaLabel,
  textareaRoot,
  textareaSection,
  textareaWrapper,
} from '@mage-ui/styled-system/recipes';
import { Textarea as TextareaMantine } from '@mantine/core';

export type TextareaProps = Omit<ComponentProps<'textarea'>, 'size'> & {
  name?: string;
  label?: string;
  description?: string;
  error?: string;
  classNames?: {
    root?: string;
    label?: string;
    description?: string;
    error?: string;
    wrapper?: string;
    input?: string;
    section?: string;
  };
  startSlot?: ReactNode;
  endSlot?: ReactNode;
  autosize?: boolean;
};

export const Textarea = ({
  classNames,
  startSlot,
  endSlot,
  autosize = true,
  onChange,
  ...props
}: TextareaProps) => {
  return (
    <TextareaMantine
      classNames={{
        root: cx(classNames?.root ?? textareaRoot(), 'group'),
        label: classNames?.label ?? textareaLabel(),
        required: classNames?.label ?? textareaLabel(),
        description: classNames?.description ?? textareaDescription(),
        error: classNames?.error ?? textareaError(),
        wrapper: classNames?.wrapper ?? textareaWrapper(),
        input: classNames?.input ?? textareaInput(),
        section: classNames?.section ?? textareaSection(),
      }}
      leftSection={startSlot}
      rightSection={endSlot}
      autosize={autosize}
      {...props}
    />
  );
};
